import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';
let abortControllerFetchTextureGroups = null;

/**
 * Gọi API lấy danh sách nhóm texture
 * @param {Object} values Tham số truyền vào
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 * @param {string} values.supplier Nhà cung cấp
 */
export const fetchTextureGroups = createAsyncThunk(
  'get/textures/v3/list_price_groups',
  async (
    { offset, limit, supplier, priceCollectionTypes, kw },
    { dispatch }
  ) => {
    try {
      if (abortControllerFetchTextureGroups) {
        abortControllerFetchTextureGroups.abort();
      }
      abortControllerFetchTextureGroups = new AbortController();

      const res = await callApi({
        endpoint: 'textures/v3/list_price_groups',
        method: 'get',
        params: {
          offset,
          limit,
          supplier,
        },
        signal: abortControllerFetchTextureGroups.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response.count, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  },
  {
    condition: (arg, { getState }) => {
      const { texture: state } = getState();

      // Chặn request nếu đang loading
      if (JSON.stringify(state.textures.preParams) === JSON.stringify(arg)) {
        return false;
      }
      return true;
    },
  }
);

let abortControllerFetchTextures = null;

/**
 * Gọi API lấy danh sách texture
 * @param {Object} values Tham số truyền vào
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 * @param {string} values.supplier Nhà cung cấp
 * @param {string} values.priceCollectionTypes Loại ván
 * @param {string} values.kw keyword tìm kiếm
 */
export const fetchTextures = createAsyncThunk(
  'get/textures/v3/textures',
  async (
    { offset, limit, supplier, priceCollectionTypes, kw },
    { dispatch }
  ) => {
    try {
      if (abortControllerFetchTextures) {
        abortControllerFetchTextures.abort();
      }
      abortControllerFetchTextures = new AbortController();

      const res = await callApi({
        endpoint: 'textures/v3/textures',
        method: 'get',
        params: {
          offset,
          limit,
          supplier,
          price_collection_types: priceCollectionTypes,
          kw,
        },
        signal: abortControllerFetchTextures.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response.count, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  },
  {
    condition: (arg, { getState }) => {
      const { texture: state } = getState();

      // Chặn request nếu đang loading
      if (JSON.stringify(state.textures.preParams) === JSON.stringify(arg)) {
        return false;
      }
      return true;
    },
  }
);

let abortControllerFetchAlumDoorTextures = null;

/**
 * Gọi API lấy danh sách texture
 * @param {Object} values Tham số truyền vào
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 * @param {string} values.supplier Nhà cung cấp
 * @param {string} values.priceCollectionTypes Loại ván
 * @param {string} values.code Mã texture
 */
export const fetchAlumDoorTextures = createAsyncThunk(
  'get/modules/v3/alu_types/',
  async ({ offset, limit, code }, { dispatch }) => {
    try {
      if (abortControllerFetchAlumDoorTextures) {
        abortControllerFetchAlumDoorTextures.abort();
      }
      abortControllerFetchAlumDoorTextures = new AbortController();

      const res = await callApi({
        endpoint: 'modules/v3/alu_types/',
        method: 'get',
        params: {
          offset,
          limit,
          code,
        },
        signal: abortControllerFetchAlumDoorTextures.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data: data?.alu_types, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  },
  {
    condition: (arg, { getState }) => {
      const { texture: state } = getState();

      // Chặn request nếu đang loading
      if (JSON.stringify(state.textures.preParams) === JSON.stringify(arg)) {
        return false;
      }
      return true;
    },
  }
);

/**
 * Gọi API lấy danh sách texture
 * @param {Object} values Tham số truyền vào
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 * @param {string} values.priceCollectionTypes Loại ván
 * @param {string} values.code Mã texture
 */
export const fetchSpecialTextures = createAsyncThunk(
  'get/textures/v3/special-textures',
  async (
    { offset, limit, supplier, priceCollectionTypes, code, special },
    { dispatch }
  ) => {
    try {
      const res = await callApi({
        endpoint: 'textures/v3/textures',
        method: 'get',
        params: {
          offset,
          limit,
          supplier,
          code,
          special,
          price_collection_types: priceCollectionTypes,
        },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response.count, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
    }
  },
  {
    condition: (arg, { getState }) => {
      const { texture: state } = getState();

      // Chặn request nếu đang loading
      if (JSON.stringify(state.textures.preParams) === JSON.stringify(arg)) {
        return false;
      }
      return true;
    },
  }
);

/** * Gọi API lấy chi tiết texture
 * @param {string} id ID texture
 */
export const fetchTextureDetail = createAsyncThunk(
  'get/textures/v3/texture/{id}',
  async ({ id }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'textures/v3/texture/' + id,
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/** * Gọi API lấy giá texture
 * @param {Object} values Tham số truyền vào
 * @param {string} values.catalogId ID catalog
 * @param {string} values.type Loại giá
 */
export const fetchPriceTexture = createAsyncThunk(
  'get/textures/v3/get-price/texture',
  async ({ catalogId, type }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'textures/v3/get-price/texture',
        method: 'get',
        params: {
          catalog_id: catalogId,
          type,
        },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

let abortControllerFetchGlasses = null;

/**
 * Gọi API lấy danh sách kính
 * @param {Object} values Tham số truyền vào
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 * @param {string} values.supplier Nhà cung cấp
 */
export const fetchGlasses = createAsyncThunk(
  'get/modules/v3/glass_types/',
  async ({ offset, limit, product_type }, { dispatch }) => {
    try {
      if (abortControllerFetchGlasses) {
        abortControllerFetchGlasses.abort();
      }
      abortControllerFetchGlasses = new AbortController();

      const res = await callApi({
        endpoint: 'modules/v3/glass_types/',
        method: 'get',
        params: {
          offset,
          limit,
          product_type,
        },
        signal: abortControllerFetchGlasses.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data?.glass_types;
        return { data, total: response.count, offset };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  },
  {
    condition: (arg, { getState }) => {
      const { texture: state } = getState();

      // Chặn request nếu đang loading
      if (JSON.stringify(state.textures.preParams) === JSON.stringify(arg)) {
        return false;
      }
      return true;
    },
  }
);
